const baseUrl = '/Address';
export const addressRoutes = {
  baseUrl: "".concat(baseUrl),
  validateAddress: "".concat(baseUrl, "/validate-address"),
  batchGetAddress: "".concat(baseUrl, "/batch-get-address"),
  parseAddress: "".concat(baseUrl, "/parse-address")
};